module.exports = __webpack_public_path__ + "static/media/ACI 25yrs Campaign Mnemonic-03.8c6d5392.jpg";